module.exports = __webpack_public_path__ + "static/media/play-player-shooting-failed.87f0fb24.png";